import Repository from "../../repository";

export default {
    Export: (payload) => Repository.post(`/api/ExportExcel/Export`, payload),
    GetListExportExcel: (payload) => Repository.post(`/api/ExportExcel/GetListExportExcel`, payload),
    DeleteExcelTemplate: (payload) => Repository.post(`/api/ExportExcel/DeleteExcelTemplate`, payload),
    Import: (payload) => Repository.post(`/api/ImportExcel/Import`, payload),
}
